import {Component, useContext} from "react";
import {ProjectDto} from "../../../api/psc";
import {Box, Button, Card, Skeleton, Stack, Typography, useTheme} from "@mui/material";
import {useSelector} from "react-redux";
import {RootState} from "../../../slices/Store";
import {DefaultDarkProjectImagePath, DefaultProjectImagePath} from "../../../constants/ProjectConstants";
import {CardInformation} from "../../../components/exports";
import ProjectDetailDialog from "../../project-detail/ProjectDetailDialog";
import {DialogContext} from "../../../contexts/DialogueContext";
import {useNavigate} from "react-router-dom";

export default function ProjectCompactItem(props: { project: ProjectDto }) {

    const navigate = useNavigate();

    const sharedState = useSelector((state: RootState) => state.shared);

    const theme = useTheme();
    const {openDialog, closeDialog} = useContext(DialogContext);


    const city = sharedState.baseInfo.cities
        .find((c) => c.id === props.project.cityId);

    const region = city?.regions
        .find((c) => c.id === props.project.regionId);

    const subRegion = region?.subregions
        .find((c) => c.id === props.project.subRegionId);

    const phase = sharedState.baseInfo.phaseList
        .find((c) => c.id === props.project.phaseId);

    const projectPlaceHolder =
        theme.palette.mode === "light"
            ? DefaultProjectImagePath
            : DefaultDarkProjectImagePath;

    function handleOpenProjectDetailDialog() {
        window.open(`/project/${props.project.hashId}`, '_blank')
    }

    return <Card sx={{p: 2}}>

        <Stack gap={2}>
            <Stack direction='row' alignItems='center' gap={2}>

                <Box>
                    <img style={{borderRadius: '8px'}} width={110} height={80}
                         src={props.project.photo?.imageThumbnailUrl ?? ''}/>
                </Box>

                <Stack direction='column' gap={1} sx={{width: '100%'}}>

                    <CardInformation
                        title={
                            "مرحله"
                        }
                        value={
                            phase?.title
                        }
                    />

                    <CardInformation
                        title={
                            "طبقه / واحد"
                        }
                        value={
                            `${props.project.floors} / ${props.project.units}`
                        }
                    />
                    <CardInformation
                        title={
                            "متراژ / زیربنا"
                        }
                        value={
                            `${props.project.groundArea} / ${props.project.residentialArea}`
                        }
                    />

                </Stack>
            </Stack>

            <Stack gap={1}>
                <Stack
                    direction="row"
                    spacing={0.5}
                    flexWrap="nowrap"
                    divider={
                        <Typography
                            fontSize="smaller"
                            color="text.secondary">/</Typography>}>

                    <Typography
                        color="text.secondary"
                        noWrap
                        fontSize="smaller">
                        {city?.title}
                    </Typography>

                    <Typography
                        color="text.secondary"
                        noWrap
                        fontSize="smaller">
                        {region?.title}
                    </Typography>

                    <Typography
                        color="text.secondary"
                        noWrap
                        fontSize="smaller">
                        {subRegion?.title}
                    </Typography>


                </Stack>

                <Typography noWrap sx={{fontSize: 12}}>
                    {
                        props.project.address || "بدون آدرس"
                    }
                </Typography>
            </Stack>

            <Button variant='outlined' onClick={handleOpenProjectDetailDialog}>مشاهده جزییات</Button>

        </Stack>

    </Card>
}
